<template>
  <button class="text--bold link link--iconleft fs-14" @click="openPDFHandler">
    <slot></slot>
  </button>
</template>

<script setup>
import { ref, defineProps } from 'vue';

const props = defineProps({
  pdfUrl: {
    type: String,
    default: '',
  },
});

const openPDFHandler = () => {
  // Open the PDF in a new window
  if (props.pdfUrl) {
    window.open(props.pdfUrl, '_blank');
  }
};
</script>
